import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import {
  Dialog,
  DialogActions,
  Divider,
  Grid,
  IconButton
} from '@material-ui/core';
import React from 'react';
import { RfqRewriteDialogStyles } from './styles';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
  open: boolean;
  onClose: () => void;
}
export default function NewRfqRewriteDialog(props: Props) {
  const classes = RfqRewriteDialogStyles();
  const { open, onClose } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      maxWidth="xs"
    >
      <Grid className={classes.header}>
        <CustomizedTypography variant="h4" fontWeight="700">
          견적서요청서 다시 작성
        </CustomizedTypography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid className={classes.content}>
        <CustomizedTypography variant="h4" color="textPrimary">
          첨부 파일 파일을 다시 첨부할 필요 없어요.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          color="textSecondary"
          gutterBottoms={24}
        >
          작성했던 이전 요청서의 첨부 파일을 불러옵니다. 물론 불러온 첨부 파일을
          삭제하거나 새로운 첨부 파일을 추가할 수 있습니다.
        </CustomizedTypography>
        <CustomizedTypography variant="h4" color="textPrimary">
          기존 요청서가 마감됩니다.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          color="textSecondary"
          gutterBottoms={21}
        >
          동일한 프로젝트의 요청서를 다시 작성하는 것이므로 새로 등록하면 기존
          요청서는 마감 처리됩니다. 마감된 요청서는 새로운 파트너들에게 노출되지
          않고 새로운 견적서를 받을 수 없습니다.
        </CustomizedTypography>
      </Grid>
      <Divider />
      <DialogActions className={classes.footer}>
        <CustomizedButton className={classes.confirmButton} onClick={onClose}>
          확인
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
}
